module.exports = __webpack_public_path__ + "img/Bypassing Benefits Infographic.14bdf5f4.png";